import { useQuery } from "@tanstack/react-query";
import {
  getIdentityVerificationStatus,
  IdentityVerificationRecord,
} from "../api/identity.api";

export function useIdentityVerificationStatus() {
  return useQuery<IdentityVerificationRecord>({
    queryKey: ["identity", "verification-session"],
    queryFn: () => getIdentityVerificationStatus(),
    refetchInterval: (query) => {
      const status = (query.state.data as IdentityVerificationRecord | undefined)
        ?.status;
      if (!status) return 15000;
      return status === "verified" || status === "canceled" ? false : 15000;
    },
    staleTime: 15000,
  });
}

